






































import Vue from 'vue'
import {
  Configuration,
  OfficerDetail,
  OfficerMeetingDetail,
  ConferenceDoctorOfficerRestControllerApi,
} from '@/types/api-docs'
import CommitteeDetailForm from '@/components/CommitteeDetailForm.vue'

export interface DataType {
  pageName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breadcrumbs: Array<any>
  officer?: OfficerDetail
  officerMeetings: Array<OfficerMeetingDetail>
  officersId: number
  isFormValid: boolean
}

const api = new ConferenceDoctorOfficerRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export default Vue.extend({
  components: {
    CommitteeDetailForm,
  },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: '理事･役員会一覧',
          href: '/member/officers',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      officer: undefined,
      officerMeetings: [],
      officersId: Number(this.$route.params.id),
      isFormValid: true,
    }
  },
  async mounted() {
    await this.fetchOfficerDetail()
    await this.fetchOfficerMeetingDetails()
  },
  methods: {
    async fetchOfficerDetail() {
      const { data } = await api.fetchMemberOfficerMaster(this.officersId)
      this.officer = data
    },
    async fetchOfficerMeetingDetails() {
      const { data } = await api.fetchMemberOfficerMasterMeetings(this.officersId)
      this.officerMeetings = data.content ? data.content : []
    },
  },
})
